import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { formatScheduledDate, formatScheduledDay } from './FollowUpBubble.functions';

/** INT-1505: formats a scheduled-message date in the reader's language. */
export function useScheduledDateFormat() {
  const { t } = useTranslation('chat/chat');

  return useCallback(
    (date: string) => {
      const months = t('scheduledMessage.months', { returnObjects: true });
      return formatScheduledDate(date, {
        now: new Date(),
        labels: {
          today: (time) => t('scheduledMessage.today', { time }),
          tomorrow: (time) => t('scheduledMessage.tomorrow', { time }),
          months: Array.isArray(months) ? months : [],
        },
      });
    },
    [t],
  );
}

/** INT-1500 U7 (D7): formats a day ("25 sep") in the reader's language. */
export function useScheduledDayFormat() {
  const { t } = useTranslation('chat/chat');

  return useCallback(
    (date: string) => {
      const months = t('scheduledMessage.months', { returnObjects: true });
      return formatScheduledDay(date, {
        now: new Date(),
        months: Array.isArray(months) ? months : [],
      });
    },
    [t],
  );
}

